// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3jl_n","content":"GlobalSearch_content__3vx5R"};